
import "./style/sign.css";
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../contextApi/ContextApi';
import { SignContext } from '../../../contextApi/SignContext';
import SignInput from './signComponents/SignInput';

export default function Signup({website, _minWidth, _height}) {

    const {setSignupEmail, setSignupPass, setSignupPhone, setSignupRePass, setSignupName, signupFlag, addUser} = useContext(SignContext);
    const {primary_color, secondary_color, accent_color, setToastMessage} = useContext(AppContext);
    const nav = useNavigate();

    return (
        <div className='sign_container' dir='rtl'>
            <div className='sign_form_container'>
                <form className="sign_form" style={{minWidth:`${_minWidth}px`, height:`${_height}vh`, backgroundColor:primary_color, color:accent_color, border:`0.5px solid ${accent_color}`, boxShadow:`2px 2px 4px ${accent_color}`}} onSubmit={(e)=>{e.preventDefault(); addUser(website, nav, setToastMessage)}}>
                    <div className="sign_form_inputsDiv">
                        <div className='sign_form_twoInputsDiv'>
                            <SignInput _class={"sign_form_twoInputsDiv_subDiv"} id={"sign_name"} label={"שם מלא"} type={"text"} placeholder={"ישראל ישראלי"} autoCompleteType={"username"} setState={setSignupName}/>
                            <SignInput _class={"sign_form_twoInputsDiv_subDiv"} id={"sign_phone"} label={"מס' פלאפון"} type={"text"} placeholder={"0501234567"} autoCompleteType={"tel"} setState={setSignupPhone}/>
                        </div>
                        <SignInput _class={"sign_form_oneInputsDiv"} id={"sign_email"} label={"אימייל"} type={"email"} placeholder={"myName@mail.com"} autoCompleteType={"email"} setState={setSignupEmail}/>

                        <div className='sign_form_twoInputsDiv'>
                            <SignInput _class={"sign_form_twoInputsDiv_subDiv"} id={"sign_password"} label={"סיסמא"} type={"password"} placeholder={"SomeP@$$w0rd123"} autoCompleteType={"current-password"} setState={setSignupPass}/>
                            <SignInput _class={"sign_form_twoInputsDiv_subDiv"} id={"sign_rePassword"} label={"סיסמא חוזרת"} type={"password"} placeholder={"SomeP@$$w0rd123"} autoCompleteType={"current-password"} setState={setSignupRePass}/>
                        </div>

                    </div>
                    <button className='sign_btn' disabled={signupFlag} style={{backgroundColor:secondary_color, color:accent_color}}>{signupFlag ? "המתן..." : "הרשמה"}</button>
                </form>
            </div>
            <a className='signin_signupButton' style={{color:accent_color,textShadow:`2px 2px 4px ${primary_color}`}} href={`/${website?.settings?.domain}/signin`}>יש לי משתמש - אני רוצה להתחבר</a>
        </div>
    )
}
